import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlXLayoutObject from './dhtmlXLayoutObject';
import dhtmlXLayoutCell from './dhtmlXLayoutCell';

var dhtmlXCellObject = (function () {
    function dhtmlXCellObject(e, a) {
        this.cell = document.createElement("DIV");
        this.cell.className = "dhx_cell" + (a || "");
        this._idd = e;
        this._isCell = true;
        this.conf = {
            borders: true,
            idx: {},
            css: a || "",
            idx_data: {
                cont: "dhx_cell_cont",
                pr1: "dhx_cell_progress_bar",
                pr2: "dhx_cell_progress_img",
                pr3: "dhx_cell_progress_svg",
                menu: "dhx_cell_menu",
                toolbar: "dhx_cell_toolbar",
                ribbon: "dhx_cell_ribbon",
                sb: "dhx_cell_statusbar",
                cover: "dhx_cell_cover"
            },
            ofs_nodes: { t: {}, b: {} }
        };
        this.dataNodes = {};
        this.views = {};
        var c = document.createElement("DIV");
        c.className = "dhx_cell_cont" + this.conf.css;
        this.cell.appendChild(c);
        c = null;
        this.conf.view = "def";
        this.conf.views_loaded = {};
        this.conf.views_loaded[this.conf.view] = true;
        window.dhx4._eventable(this);
        this._updateIdx();
    }
    dhtmlXCellObject.prototype._updateIdx = function () {
        for (var g in this.conf.idx) {
            this.conf.idx[g] = null;
            delete this.conf.idx[g];
        }
        for (var m = 0; m < this.cell.childNodes.length; m++) {
            var h = this.cell.childNodes[m].className;
            for (var g1 in this.conf.idx_data) {
                var l = new RegExp(this.conf.idx_data[g1]);
                if (h.match(l) != null) {
                    this.conf.idx[g1] = m;
                }
            }
        }
        this.callEvent("_onIdxUpdated", []);
    };
    dhtmlXCellObject.prototype._adjustAttached = function () {
        for (var g in this.dataNodes) {
            if (this.dataNodes[g] != null &&
                typeof this.dataNodes[g].setSizes == "function") {
                this.dataNodes[g].setSizes();
            }
        }
        if (this.dataObj != null && typeof this.dataObj.setSizes == "function") {
            if (this.dataType == "layout" &&
                typeof dhtmlXLayoutCell == "function" &&
                this instanceof dhtmlXLayoutCell &&
                this.dataObj._getMainInst() != this.layout._getMainInst()) {
                this.dataObj.setSizes();
                return;
            }
            this.dataObj.setSizes.apply(this.dataObj, arguments);
        }
    };
    dhtmlXCellObject.prototype._setSize = function (v, s, A, n, o, r, l, m) {
        if (this.conf.size == null) {
            this.conf.size = {};
        }
        if (m == null) {
            m = {};
        }
        var C = { left: "x", top: "y", width: "w", height: "h" };
        this.conf.size.x = v;
        this.conf.size.y = s;
        this.conf.size.w = Math.max(A, 0);
        this.conf.size.h = Math.max(n, 0);
        for (var u in C) {
            var g = m[u] || u;
            this.cell.style[g] = this.conf.size[C[u]] + "px";
        }
        this.callEvent("_onSetSize", []);
        if (r !== true) {
            this._adjustCont(o, l);
        }
        else {
            this._adjustAttached(o);
        }
        this._adjustProgress();
    };
    dhtmlXCellObject.prototype._adjustCont = function (o, m) {
        var n = this.cell.childNodes[this.conf.idx.cont];
        if (typeof dhtmlXLayoutCell == "function" &&
            this instanceof dhtmlXLayoutCell &&
            this.conf.collapsed == true) {
            n.style.left = n.style.top = "0px";
            n.style.width = n.style.height = "200px";
            n = null;
            return;
        }
        var l = 0;
        for (var g in this.conf.ofs_nodes.t) {
            var h = this.conf.ofs_nodes.t[g];
            l +=
                h == "func"
                    ? this[g]()
                    : h == true
                        ? this.cell.childNodes[this.conf.idx[g]].offsetHeight
                        : 0;
        }
        var r = 0;
        for (var g_1 in this.conf.ofs_nodes.b) {
            var h = this.conf.ofs_nodes.b[g_1];
            r +=
                h == "func"
                    ? this[g_1]()
                    : h == true
                        ? this.cell.childNodes[this.conf.idx[g_1]].offsetHeight
                        : 0;
        }
        n.style.left = "0px";
        n.style.top = l + "px";
        if (this.conf.cells_cont == null) {
            this.conf.cells_cont = {};
            n.style.width = this.cell.offsetWidth + "px";
            n.style.height = Math.max(this.cell.offsetHeight - l - r, 0) + "px";
            this.conf.cells_cont.w = parseInt(n.style.width) - n.offsetWidth;
            this.conf.cells_cont.h = parseInt(n.style.height) - n.offsetHeight;
        }
        n.style.left = "0px";
        n.style.top = l + "px";
        n.style.width =
            Math.max(this.cell.offsetWidth + this.conf.cells_cont.w, 0) + "px";
        n.style.height =
            Math.max(this.conf.size.h - l - r + this.conf.cells_cont.h, 0) + "px";
        n = null;
        this._adjustAttached(o);
        if (m == "expand" && this.dataType == "editor" && this.dataObj != null) {
            this.dataObj._prepareContent(true);
        }
    };
    dhtmlXCellObject.prototype._mtbUpdBorder = function () {
        var h = ["menu", "toolbar", "ribbon"];
        for (var m = 0; m < h.length; m++) {
            if (this.conf.idx[h[m]] != null) {
                var n = this.cell.childNodes[this.conf.idx[h[m]]];
                var l = "dhx_cell_" + h[m] + "_no_borders";
                var g = "dhx_cell_" + h[m] + "_def";
                n.className = n.className.replace(new RegExp(this.conf.borders ? l : g), this.conf.borders ? g : l);
                n = null;
            }
        }
    };
    dhtmlXCellObject.prototype._resetSizeState = function () {
        this.conf.cells_cont = null;
    };
    dhtmlXCellObject.prototype._viewSave = function (l) {
        this.views[l] = {
            borders: this.conf.borders,
            ofs_nodes: { t: {}, b: {} },
            url_data: this.conf.url_data,
            dataType: this.dataType,
            dataObj: this.dataObj,
            cellCont: [],
            dataNodes: {},
            dataNodesCont: {}
        };
        var m = this.cell.childNodes[this.conf.idx.cont];
        while (m.childNodes.length > 0) {
            this.views[l].cellCont.push(m.firstChild);
            m.removeChild(m.firstChild);
        }
        m = null;
        this.dataType = null;
        this.dataObj = null;
        this.conf.url_data = null;
        for (var h in this.dataNodes) {
            for (var g in this.conf.ofs_nodes) {
                if (typeof this.conf.ofs_nodes[g][h] != "undefined") {
                    this.views[l].ofs_nodes[g][h] = this.conf.ofs_nodes[g][h];
                    this.conf.ofs_nodes[g][h] = null;
                    delete this.conf.ofs_nodes[g][h];
                }
            }
            this.views[l].dataNodesCont[h] = this.cell.childNodes[this.conf.idx[h]];
            this.cell.removeChild(this.cell.childNodes[this.conf.idx[h]]);
            this.views[l].dataNodes[h] = this.dataNodes[h];
            this.dataNodes[h] = null;
            delete this.dataNodes[h];
            this._updateIdx();
        }

        this.callEvent("_onViewSave", [l]);
    };
    dhtmlXCellObject.prototype._viewRestore = function (l) {
        if (this.views[l] == null) {
            return;
        }
        this.dataObj = this.views[l].dataObj;
        this.dataType = this.views[l].dataType;
        this.conf.url_data = this.views[l].url_data;
        for (var m = 0; m < this.views[l].cellCont.length; m++) {
            this.cell.childNodes[this.conf.idx.cont].appendChild(this.views[l].cellCont[m]);
        }
        for (var h in this.views[l].dataNodes) {
            this.dataNodes[h] = this.views[l].dataNodes[h];
            if (h == "menu") {
                this.cell.insertBefore(this.views[l].dataNodesCont[h], this.cell.childNodes[this.conf.idx.toolbar || this.conf.idx.cont]);
            }
            if (h == "toolbar") {
                this.cell.insertBefore(this.views[l].dataNodesCont[h], this.cell.childNodes[this.conf.idx.cont]);
            }
            if (h == "ribbon") {
                this.cell.insertBefore(this.views[l].dataNodesCont[h], this.cell.childNodes[this.conf.idx.cont]);
            }
            if (h == "sb") {
                this.cell.appendChild(this.views[l].dataNodesCont[h]);
            }
            this._updateIdx();
        }
        for (var h_1 in this.views[l].ofs_nodes) {
            for (var g in this.views[l].ofs_nodes[h_1]) {
                this.conf.ofs_nodes[h_1][g] = this.views[l].ofs_nodes[h_1][g];
            }
        }
        if (this.conf.borders != this.views[l].borders) {

            this[this.views[l].borders ? "_showBorders" : "_hideBorders"](true);
        }
        if (this.dataType == "url" &&
            this.conf.url_data != null &&
            this.conf.url_data.ajax == false &&
            this.conf.url_data.post_data != null) {
            this.reloadURL();
        }
        this.callEvent("_onViewRestore", [l]);
        this._viewDelete(l);
    };
    dhtmlXCellObject.prototype._viewDelete = function (l) {
        if (this.views[l] == null) {
            return;
        }
        this.views[l].borders = null;
        for (var h in this.views[l].ofs_nodes) {
            for (var g in this.views[l].ofs_nodes[h]) {
                this.views[l].ofs_nodes[h][g] = null;
            }
            this.views[l].ofs_nodes[h] = null;
        }
        this.views[l].dataType = null;
        this.views[l].dataObj = null;
        this.views[l].url_data = null;
        for (var m = 0; m < this.views[l].cellCont.length; m++) {
            this.views[l].cellCont[m] = null;
        }
        this.views[l].cellCont = null;
        for (var h_2 in this.views[l].dataNodes) {
            this.views[l].dataNodes[h_2] = null;
            this.views[l].dataNodesCont[h_2] = null;
        }
        this.views[l].dataNodes = this.views[l].dataNodesCont = null;
        this.views[l] = null;
        delete this.views[l];
    };
    return dhtmlXCellObject;
})();
dhtmlXCellObject.prototype.showView = function (a) {
    if (this.conf.view == a) {
        return false;
    }
    this._viewSave(this.conf.view);
    this._viewRestore(a);
    this._updateIdx();
    this._adjustCont();
    this.conf.view = a;
    var c = typeof this.conf.views_loaded[this.conf.view] == "undefined";
    this.conf.views_loaded[this.conf.view] = true;
    return c;
};
dhtmlXCellObject.prototype.getViewName = function () {
    return this.conf.view;
};
dhtmlXCellObject.prototype.unloadView = function (g) {
    if (g == this.conf.view) {
        var h = this.conf.unloading;
        this.conf.unloading = true;
        if (typeof this.detachMenu == "function") {
            this.detachMenu();
        }
        if (typeof this.detachToolbar == "function") {
            this.detachToolbar();
        }
        if (typeof this.detachRibbon == "function") {
            this.detachRibbon();
        }
        this.detachStatusBar();
        this._detachObject(null, true);
        this.conf.unloading = h;
        if (!this.conf.unloading) {
            this._adjustCont(this._idd);
        }
        return;
    }
    if (this.views[g] == null) {
        return;
    }
    var e = this.views[g];
    for (var c in e.dataNodes) {
        if (typeof e.dataNodes[c].unload == "function") {
            e.dataNodes[c].unload();
        }
        e.dataNodes[c] = null;
        e.dataNodesCont[c] = null;
    }
    if (e.dataType == "url") {
        if (e.cellCont != null && e.cellCont[0] != "null") {
            this._detachURLEvents(e.cellCont[0]);
        }
    }
    else {
        if (e.dataObj != null) {
            if (typeof e.dataObj.unload == "function") {
                e.dataObj.unload();
            }
            else {
                if (typeof e.dataObj.destructor == "function") {
                    e.dataObj.destructor();
                }
            }
            e.dataObj = null;
        }
    }
    e = null;
    this._viewDelete(g);
    if (typeof this.conf.views_loaded[g] != "undefined") {
        delete this.conf.views_loaded[g];
    }
};
dhtmlXCellObject.prototype.getId = function () {
    return this._idd;
};
dhtmlXCellObject.prototype.progressOn = function () {
    if (this.conf.progress == true) {
        return;
    }
    this.conf.progress = true;
    var c = document.createElement("DIV");
    c.className = this.conf.idx_data.pr1;
    var a = document.createElement("DIV");
    if (this.conf.skin == "material" &&
        (window.dhx4.isFF ||
            window.dhx4.isChrome ||
            window.dhx4.isOpera ||
            window.dhx4.isEdge)) {
        a.className = this.conf.idx_data.pr3;
        a.innerHTML =
            '<svg class="dhx_cell_prsvg" viewBox="25 25 50 50"><circle class="dhx_cell_prcircle" cx="50" cy="50" r="20"/></svg>';
    }
    else {
        a.className = this.conf.idx_data.pr2;
    }
    if (this.conf.idx.cover != null) {
        this.cell.insertBefore(a, this.cell.childNodes[this.conf.idx.cover]);
    }
    else {
        this.cell.appendChild(a);
    }
    this.cell.insertBefore(c, a);
    c = a = null;
    this._updateIdx();
    this._adjustProgress();
};
dhtmlXCellObject.prototype.progressOff = function () {
    if (this.conf.progress != true) {
        return;
    }
    for (var c in { pr3: 3, pr2: 2, pr1: 1 }) {
        var e = this.cell.childNodes[this.conf.idx[c]];
        if (e != null) {
            e.parentNode.removeChild(e);
        }
        e = null;
    }
    this.conf.progress = false;
    this._updateIdx();
};
dhtmlXCellObject.prototype._adjustProgress = function () {
    if (this.conf.idx.pr1 == null) {
        return;
    }
    if (!this.conf.pr) {
        this.conf.pr = {};
    }
    var c = this.cell.childNodes[this.conf.idx.pr1];
    var a = this.cell.childNodes[this.conf.idx.pr2] ||
        this.cell.childNodes[this.conf.idx.pr3];
    if (!this.conf.pr.ofs) {
        a.style.width = c.offsetWidth + "px";
        a.style.height = c.offsetHeight + "px";
        this.conf.pr.ofs = {
            w: a.offsetWidth - a.clientWidth,
            h: a.offsetHeight - a.clientHeight
        };
    }
    a.style.width = c.offsetWidth - this.conf.pr.ofs.w + "px";
    a.style.height = c.offsetHeight - this.conf.pr.ofs.h + "px";
    c = a = null;
};
dhtmlXCellObject.prototype._showCellCover = function () {
    if (this.conf.cover == true) {
        return;
    }
    this.conf.cover = true;
    var a = document.createElement("DIV");
    a.className = this.conf.idx_data.cover;
    this.cell.appendChild(a);
    a = null;
    this._updateIdx();
};
dhtmlXCellObject.prototype._hideCellCover = function () {
    if (this.conf.cover != true) {
        return;
    }
    this.cell.removeChild(this.cell.childNodes[this.conf.idx.cover]);
    this._updateIdx();
    this.conf.cover = false;
};
dhtmlXCellObject.prototype._showBorders = function (a) {
    if (this.conf.borders) {
        return;
    }
    this.conf.borders = true;
    this.cell.childNodes[this.conf.idx.cont].className =
        "dhx_cell_cont" + this.conf.css;
    this.conf.cells_cont = null;
    this._mtbUpdBorder();
    this.callEvent("_onBorderChange", [true]);
    if (a !== true) {
        this._adjustCont(this._idd);
    }
};
dhtmlXCellObject.prototype._hideBorders = function (a) {
    if (!this.conf.borders) {
        return;
    }
    this.conf.borders = false;
    this.cell.childNodes[this.conf.idx.cont].className =
        "dhx_cell_cont" + this.conf.css + " dhx_cell_cont_no_borders";
    this.conf.cells_cont = null;
    this._mtbUpdBorder();
    this.callEvent("_onBorderChange", [false]);
    if (a !== true) {
        this._adjustCont(this._idd);
    }
};
dhtmlXCellObject.prototype._getWidth = function () {
    return this.cell.offsetWidth;
};
dhtmlXCellObject.prototype._getHeight = function () {
    return this.cell.offsetHeight;
};
dhtmlXCellObject.prototype.showInnerScroll = function () {
    this.cell.childNodes[this.conf.idx.cont].style.overflow = "auto";
};
dhtmlXCellObject.prototype._unload = function () {
    this.conf.unloading = true;
    this.callEvent("_onCellUnload", []);
    this.progressOff();
    this.unloadView(this.conf.view);
    this.dataNodes = null;
    this.cell.parentNode.removeChild(this.cell);
    this.cell = null;
    window.dhx4._eventable(this, "clear");
    for (var c in this.views) {
        this.unloadView(c);
    }
    this.conf = null;
    for (var c_1 in this) {
        this[c_1] = null;
    }
};
dhtmlXCellObject.prototype.attachObject = function (g, e) {
    if (window.dhx4.s2b(e) &&
        !(typeof window.dhtmlXWindowsCell == "function" &&
            this instanceof window.dhtmlXWindowsCell)) {
        e = false;
    }
    if (typeof g == "string") {
        g = document.getElementById(g);
    }
    if (g.parentNode == this.cell.childNodes[this.conf.idx.cont]) {
        g = null;
        return;
    }
    if (e) {
        g.style.display = "";
        var a = g.offsetWidth;
        var c = g.offsetHeight;
    }
    this._attachObject(g);
    this.dataType = "obj";
    g.style.display = "";
    g = null;
    if (e) {
        this._adjustByCont(a, c);
    }
};
dhtmlXCellObject.prototype.appendObject = function (a) {
    if (typeof a == "string") {
        a = document.getElementById(a);
    }
    if (a.parentNode == this.cell.childNodes[this.conf.idx.cont]) {
        a = null;
        return;
    }
    if (!this.conf.append_mode) {
        this.cell.childNodes[this.conf.idx.cont].style.overflow = "auto";
        this.conf.append_mode = true;
    }
    this._attachObject(a, null, null, true);
    this.dataType = "obj";
    a.style.display = "";
    a = null;
};
dhtmlXCellObject.prototype.detachObject = function (c, a) {
    this._detachObject(null, c, a);
};
dhtmlXCellObject.prototype.getAttachedStatusBar = function () {
    return this.dataNodes.sb;
};
dhtmlXCellObject.prototype.getAttachedObject = function () {
    if (this.dataType == "obj" ||
        this.dataType == "url" ||
        this.dataType == "url-ajax") {
        return this.cell.childNodes[this.conf.idx.cont].firstChild;
    }
    else {
        return this.dataObj;
    }
};
dhtmlXCellObject.prototype.attachURL = function (c, u, g) {
    if (g == true) {
        g = {};
    }
    var h = typeof g != "undefined" && g != false && g != null;
    if (this.conf.url_data == null) {
        this.conf.url_data = {};
    }
    this.conf.url_data.url = c;
    this.conf.url_data.ajax = u == true;
    this.conf.url_data.post_data = g == true ? {} : g || null;
    if (this.conf.url_data.xml_doc != null) {
        try {
            this.conf.url_data.xml_doc.xmlDoc.abort();
        }
        catch (n) {
            console.log(n,"----n---");
        }
        this.conf.url_data.xml_doc.xmlDoc = null;
        this.conf.url_data.xml_doc = null;
    }
    if (u == true) {
        var s = this;
        if (h) {
            var l = "";
            for (var r in g) {
                l += "&" + encodeURIComponent(r) + "=" + encodeURIComponent(g[r]);
            }
            this.conf.url_data.xml_doc = dhx4.ajax.post(c, l, function (a) {
                if (s.attachHTMLString != null &&
                    typeof a.xmlDoc.responseText == "string") {
                    s.attachHTMLString("<div style='position:relative;width:100%;height:100%;overflow:auto;'>" +
                        a.xmlDoc.responseText +
                        "</div>");
                    if (typeof s._doOnFrameContentLoaded == "function") {
                        s._doOnFrameContentLoaded();
                    }
                    s.dataType = "url-ajax";
                }
                s = a = null;
            });
        }
        else {
            this.conf.url_data.xml_doc = dhx4.ajax.get(c, function (a) {
                if (s.attachHTMLString != null &&
                    typeof a.xmlDoc.responseText == "string") {
                    s.attachHTMLString("<div style='position:relative;width:100%;height:100%;overflow:auto;'>" +
                        a.xmlDoc.responseText +
                        "</div>");
                    if (typeof s._doOnFrameContentLoaded == "function") {
                        s._doOnFrameContentLoaded();
                    }
                    s.dataType = "url-ajax";
                }
                s = a = null;
            });
        }
    }
    else {
        var m = null;
        if (this.dataType == "url") {
            m = this.getFrame();
        }
        else {
            m = document.createElement("IFRAME");
            m.frameBorder = 0;
            m.border = 0;
            m.style.width = "100%";
            m.style.height = "100%";
            m.style.position = "relative";
            this._attachObject(m);
            this.dataType = "url";
            this._attachURLEvents();
        }
        if (h) {
            var o = typeof this.conf.url_data.post_ifr == "undefined";
            this.conf.url_data.post_ifr = true;
            if (o) {
                this._attachURLEvents();
            }
            m.src = "about:blank";
        }
        else {
            m.src = c + window.dhx4.ajax._dhxr(c);
        }
        m = null;
    }
    m = null;
};
dhtmlXCellObject.prototype.reloadURL = function () {
    if (!(this.dataType == "url" || this.dataType == "url-ajax")) {
        return;
    }
    if (this.conf.url_data == null) {
        return;
    }
    this.attachURL(this.conf.url_data.url, this.conf.url_data.ajax, this.conf.url_data.post_data);
};
dhtmlXCellObject.prototype.attachHTMLString = function (str) {
    this._attachObject(null, null, str);
    var z = str.match(/<script[^>]*>[^\f]*?<\/script>/g) || [];
    for (var i = 0; i < z.length; i++) {
        var s = z[i].replace(/<([\/]{0,1})script[^>]*>/gi, "");
        if (s) {
            if (window.execScript) {
                window.execScript(s);
            }
            else {
                window.eval(s);
            }
        }
    }
};
dhtmlXCellObject.prototype.attachScheduler = function (a, m, c, g) {
    g = g || window.scheduler;
    var h = false;
    var l = null;
    if (c) {
        l = document.getElementById(c);
        if (l) {
            h = true;
        }
    }
    if (!h) {
        var e = c ||
            '<div class="dhx_cal_tab" name="day_tab" style="right:204px;"></div><div class="dhx_cal_tab" name="week_tab" style="right:140px;"></div><div class="dhx_cal_tab" name="month_tab" style="right:76px;"></div>';
        l = document.createElement("DIV");
        l.id = "dhxSchedObj_" + new Date().getTime();
        l.style.width = "100%";
        l.style.height = "100%";
        l.style.position = "relative";
        l.style.overflow = "hidden";
        l.className = "dhx_cal_container";
        l.innerHTML =
            '<div class="dhx_cal_navline"><div class="dhx_cal_prev_button">&nbsp;</div><div class="dhx_cal_next_button">&nbsp;</div><div class="dhx_cal_today_button"></div><div class="dhx_cal_date"></div>' +
                e +
                '</div><div class="dhx_cal_header"></div><div class="dhx_cal_data"></div>';
    }
    this._attachObject(l);
    this.dataType = "scheduler";
    this.dataObj = g;
    this.dataObj.setSizes = function () {
        this.update_view();
    };
    g.init(l.id, a, m);
    l = null;
    this.callEvent("_onContentAttach", []);
    return this.dataObj;
};
dhtmlXCellObject.prototype._createNode_sb = function (n, g, m, a, l) {
    if (typeof l != "undefined") {
        n = l;
    }
    else {
        var c = g || {};
        var o = typeof c.text == "string" && c.text.length > 0 ? c.text : "&nbsp;";
        var e = typeof c.height == "number" ? c.height : false;
        var nElobj = document.createElement("DIV");
        nElobj.className = "dhx_cell_statusbar_def";
        nElobj.innerHTML =
            "<div class='" +
                (c.paging == true
                    ? "dhx_cell_statusbar_paging"
                    : "dhx_cell_statusbar_text") +
                "'>" +
                o +
                "</div>";
        if (e != false) {
            nElobj.firstChild.style.height = nElobj.firstChild.style.lineHeight =
                e + "px";
        }
    }
    if (this.conf.idx.pr1 != null) {
        this.cell.insertBefore(n, this.cell.childNodes[this.conf.idx.pr1]);
    }
    else {
        this.cell.appendChild(n);
    }
    this.conf.ofs_nodes.b.sb = true;
    this._updateIdx();
    this._adjustCont(this._idd);
    return n;
};
dhtmlXCellObject.prototype.attachStatusBar = function (a) {
    if (this.dataNodes.sb) {
        return;
    }
    if (a != null && window.dhx4.s2b(a.paging) == true) {
        a.height = null;
    }
    if (this.conf.skin == "dhx_skyblue" &&
        typeof window.dhtmlXWindowsCell == "function" &&
        this instanceof window.dhtmlXWindowsCell) {
        this.cell.childNodes[this.conf.idx.cont].className +=
            " dhx_cell_statusbar_attached";
    }
    this.dataNodes.sb = this._attachObject("sb", a);
    this.dataNodes.sb.setText = function (c) {
        this.childNodes[0].innerHTML = c;
    };
    this.dataNodes.sb.getText = function () {
        return this.childNodes[0].innerHTML;
    };
    this.dataNodes.sb.onselectstart = function () {
        return false;
    };
    return this.dataNodes.sb;
};
dhtmlXCellObject.prototype.detachStatusBar = function () {
    if (!this.dataNodes.sb) {
        return;
    }
    if (this.conf.skin == "dhx_skyblue" &&
        typeof window.dhtmlXWindowsCell == "function" &&
        this instanceof window.dhtmlXWindowsCell) {
        this.cell.childNodes[this.conf.idx.cont].className = this.cell.childNodes[this.conf.idx.cont].className.replace(/\s{0,}dhx_cell_statusbar_attached/, "");
    }
    this.dataNodes.sb.setText = this.dataNodes.sb.getText = this.dataNodes.sb.onselectstart = null;
    this.dataNodes.sb = null;
    delete this.dataNodes.sb;
    this._detachObject("sb");
};
dhtmlXCellObject.prototype.showStatusBar = function () {
    this._mtbShowHide("sb", "");
};
dhtmlXCellObject.prototype.hideStatusBar = function () {
    this._mtbShowHide("sb", "none");
};
dhtmlXCellObject.prototype._mtbShowHide = function (c, a) {
    if (!this.dataNodes[c]) {
        return;
    }
    this.cell.childNodes[this.conf.idx[c]].style.display = a;
    this._adjustCont();
};
dhtmlXCellObject.prototype.getFrame = dhtmlXCellObject.prototype._getFrame = function () {
    if (this.dataType != "url") {
        return null;
    }
    return this.cell.childNodes[this.conf.idx.cont].firstChild;
};
dhtmlXCellObject.prototype._attachURLEvents = function () {
    if (this.dataType != "url") {
        return;
    }
    var e = this;
    var c = this._idd;
    var a = this.cell.childNodes[this.conf.idx.cont].firstChild;
    if (typeof this._doOnFrameMouseDown != "function") {
        this._doOnFrameMouseDown = function (g) {
            e.callEvent("_onContentMouseDown", [c, g || event]);
        };
    }
    if (typeof window.addEventListener == "function") {
        a.onload = function () {
            try {
                if (typeof e._doOnFrameMouseDown == "function") {
                    this.contentWindow.document.body.addEventListener("mousedown", e._doOnFrameMouseDown, false);
                }
            }
            catch (g) {
                console.log(g,"---------g-----");
            }
            try {
                if (typeof e._doOnFrameContentLoaded == "function") {
                    e._doOnFrameContentLoaded();
                }
            }
            catch (g) {
                console.log(g,"---------g-----");
            }
        };
    }
    else {
        a.onreadystatechange = function () {
            if (this.readyState == "complete") {
                try {
                    if (typeof e._doOnFrameMouseDown == "function") {
                        this.contentWindow.document.body.attachEvent("onmousedown", e._doOnFrameMouseDown);
                    }
                }
                catch (h) {
                    console.log(h,"---------h-----");
                }
                try {
                    if (typeof e._doOnFrameContentLoaded == "function") {
                        e._doOnFrameContentLoaded();
                    }
                }
                catch (h) {
                    console.log(h,"---------h-----");
                }
            }
        };
    }
};
dhtmlXCellObject.prototype._doOnFrameContentLoaded = function () {
    if (this.conf.url_data.post_ifr == true) {
        var l = this.getFrame().contentWindow.document;
        var h = l.createElement("FORM");
        h.method = "POST";
        h.action = this.conf.url_data.url;
        l.body.appendChild(h);
        var e = {};
        if (window.dhx4.ajax.cache != true) {
            e["dhxr" + new Date().getTime()] = "1";
        }
        for (var c in this.conf.url_data.post_data) {
            e[c] = this.conf.url_data.post_data[c];
        }
        for (var c_2 in e) {
            var g = l.createElement("INPUT");
            g.type = "hidden";
            g.name = c_2;
            g.value = e[c_2];
            h.appendChild(g);
            g = null;
        }
        this.conf.url_data.post_ifr = false;
        h.submit();
    }
    else {
        this.callEvent("_onContentLoaded", [this._idd]);
    }
};
dhtmlXCellObject.prototype._detachURLEvents = function (a) {
    if (a == null) {
        if (this.dataType != "url") {
            return;
        }
        a = this.cell.childNodes[this.conf.idx.cont].firstChild;
    }
    if (typeof window.addEventListener == "function") {
        a.onload = null;
        try {
            a.contentWindow.document.body.removeEventListener("mousedown", this._doOnFrameMouseDown, false);
        }
        catch (c) {
            console.log(c,"---------c-----");
        }
    }
    else {
        a.onreadystatechange = null;
        try {
            a.contentWindow.document.body.detachEvent("onmousedown", this._doOnFrameMouseDown);
        }
        catch (c) {
            console.log(c,"---------c-----");
        }
    }
    a = null;
};
dhtmlXCellObject.prototype._attachObject = function (h, c, g, a) {
    var jsonObj = { menu: 1, toolbar: 1, ribbon: 1, sb: 1 };
    if (typeof h == "string" && jsonObj[h] == 1) {
        return this["_createNode_" + h].apply(this, arguments);
    }
    if (a != true) {
        this._detachObject(null, true, null);
    }
    if (typeof g == "string") {
        this.cell.childNodes[this.conf.idx.cont].innerHTML = g;
    }
    else {
        this.cell.childNodes[this.conf.idx.cont].appendChild(h);
    }
    h = null;
};
dhtmlXCellObject.prototype._detachObject = function (m, c, a) {
    this.callEvent("_onBeforeContentDetach", []);
    var l = null;
    if (m == "menu" || m == "toolbar" || m == "ribbon" || m == "sb") {
        l = this.cell.childNodes[this.conf.idx[m]];
        l.parentNode.removeChild(l);
        l = null;
        this.conf.ofs_nodes[m == "sb" ? "b" : "t"][m] = false;
        this._updateIdx();
        if (!this.conf.unloading) {
            this._adjustCont(this._idd);
        }
        return;
    }
    if (c == true) {
        a = false;
    }
    else {
        if (typeof a == "undefined") {
            a = document.body;
        }
        else {
            if (typeof a == "string") {
                a = document.getElementById(a);
            }
        }
    }
    if (a === false) {
        if (this.conf.unloading == true &&
            String(this.dataType).match(/ajax/) != null) {
            if (this.conf.url_data != null && this.conf.url_data.xml_doc != null) {
                try {
                    this.conf.url_data.xml_doc.xmlDoc.abort();
                }
                catch (h) {
                    console.log(h,"----h---");
                }
                this.conf.url_data.xml_doc.xmlDoc = null;
                this.conf.url_data.xml_doc = null;
            }
        }
        if (this.dataType == "url") {
            this._detachURLEvents();
        }
        else {
            if (this.dataObj != null) {
                if (typeof this.dataObj.unload == "function") {
                    this.dataObj.unload();
                }
                else {
                    if (typeof this.dataObj.destructor == "function") {
                        this.dataObj.destructor();
                    }
                }
            }
        }
    }
    l = this.cell.childNodes[this.conf.idx.cont];
    while (l.childNodes.length > 0) {
        if (a === false) {
            l.removeChild(l.lastChild);
        }
        else {
            l.firstChild.style.display = "none";
            a.appendChild(l.firstChild);
        }
    }
    if (this.conf.append_mode) {
        l.style.overflow = "";
        this.conf.append_mode = false;
    }
    var g = this.dataType == "tabbar";
    this.dataObj = null;
    this.dataType = null;
    a = l = null;
    if (this.conf.unloading != true && g) {
        this.showHeader(true);
        this._showBorders();
    }
};
dhtmlXCellObject.prototype._attachFromCell = function (c) {
    this.detachObject(true);
    var g = "layout";
    if (typeof window.dhtmlXWindowsCell == "function" &&
        this instanceof window.dhtmlXWindowsCell) {
        g = "window";
    }
    if (typeof window.dhtmlXWindowsCell == "function" &&
        c instanceof window.dhtmlXWindowsCell &&
        c.wins.w[c._idd].conf.parked == true) {
        c.wins._winCellSetOpacity(c._idd, "open", false);
    }
    if (typeof window.dhtmlXAccordionCell == "function" &&
        c instanceof window.dhtmlXAccordionCell &&
        c.conf.opened == false) {
        c._cellSetOpacity("open", false);
    }
    for (var e in c.dataNodes) {
        this._attachObject(e, null, null, null, c.cell.childNodes[c.conf.idx[e]]);
        this.dataNodes[e] = c.dataNodes[e];
        c.dataNodes[e] = null;
        c.conf.ofs_nodes[e == "sb" ? "b" : "t"][e] = false;
        c._updateIdx();
    }
    this._mtbUpdBorder();
    if (c.dataType != null && c.dataObj != null) {
        this.dataType = c.dataType;
        this.dataObj = c.dataObj;
        while (c.cell.childNodes[c.conf.idx.cont].childNodes.length > 0) {
            this.cell.childNodes[this.conf.idx.cont].appendChild(c.cell.childNodes[c.conf.idx.cont].firstChild);
        }
        c.dataType = null;
        c.dataObj = null;
        if (this.dataType == "grid") {
            if (g == "window" && this.conf.skin == "dhx_skyblue") {
                this.dataObj.entBox.style.border = "1px solid #a4bed4";
                this.dataObj._sizeFix = 0;
            }
            else {
                this.dataObj.entBox.style.border = "0px solid white";
                this.dataObj._sizeFix = 2;
            }
        }
    }
    else {
        while (c.cell.childNodes[c.conf.idx.cont].childNodes.length > 0) {
            this.cell.childNodes[this.conf.idx.cont].appendChild(c.cell.childNodes[c.conf.idx.cont].firstChild);
        }
    }
    this.conf.view = c.conf.view;
    c.conf.view = "def";
    for (var e_1 in c.views) {
        this.views[e_1] = c.views[e_1];
        c.views[e_1] = null;
        delete c.views[e_1];
    }
    c._updateIdx();
    c._adjustCont();
    this._updateIdx();
    this._adjustCont();
    if (c.conf.progress == true) {
        c.progressOff();
        this.progressOn();
    }
    else {
        this.progressOff();
    }
    if (g == "window" && this.wins.w[this._idd].conf.parked) {
        this.wins._winCellSetOpacity(this._idd, "close", false);
    }
};
dhtmlXCellObject.prototype.attachLayout = function (a) {
    this.callEvent("_onBeforeContentAttach", ["layout"]);
    var c = document.createElement("DIV");
    c.style.width = "100%";
    c.style.height = "100%";
    c.style.position = "relative";
    c.style.overflow = "hidden";
    this._attachObject(c);
    if (typeof this._layoutMainInst != "undefined") {
        c._layoutMainInst = this._layoutMainInst;
    }
    if (typeof dhtmlXLayoutCell == "function" && this instanceof dhtmlXLayoutCell) {
        c._isParentCell = true;
        if (this.conf.skin == "material" &&
            String(this.cell.className).match(/dhx_cell_nested_layout/) == null) {
            this.cell.className += " dhx_cell_nested_layout";
        }
    }
    if (typeof a == "string") {
        a = { pattern: a };
    }
    if (typeof a.skin == "undefined") {
        a.skin = this.conf.skin;
    }
    a.parent = c;
    this.dataType = "layout";
    this.dataObj = new dhtmlXLayoutObject(a);
    if (this instanceof dhtmlXLayoutCell) {
        this.dataObj.parentLayout = this.layout;
    }
    c._layoutMainInst = null;
    a.parent = null;
    c = a = null;
    this.callEvent("_onContentAttach", []);
    return this.dataObj;
};

export default dhtmlXCellObject;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXLayoutObject/dhtmlXCellObject.js